



































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { formatDateTimeJp } from '@common/app.config';
import { CANCEL_REASON_UNSELECTED } from '@/common/constants/auth';
import {
  hasOpenCancelRequest,
  resolveCancelRequestDetail,
  resolveCancelRequestReason,
  resolveOpenCancelRequest,
} from '@/common/helpers/cancel-request';
import NewPopupConfirm from '@components/common/NewPopupConfirm.vue';
import { UserTreatment } from '@/models/user-treatment';

/**
 * Shows the reason a patient gave when filing a cancel request, at the point
 * where a member of staff decides what to do about it.
 *
 * The revert button lives in this bar on the 配送 tab, which has no button row
 * of its own. On the 問診内容 tab the button already exists in the action row
 * below, so the bar is rendered without it (showRevertButton = false) rather
 * than putting two identical buttons on one screen.
 */
@Component({
  components: { NewPopupConfirm },
})
export default class CancelRequestBar extends Vue {
  @Prop({ required: true }) readonly treatment!: UserTreatment;
  @Prop({ default: false }) readonly showRevertButton!: boolean;
  @Prop({ default: false }) readonly isReverting!: boolean;
  /** Modal names are global in vue-js-modal, so each host tab passes its own. */
  @Prop({ required: true }) readonly confirmModalName!: string;

  private formatDateTimeJp = formatDateTimeJp;

  /**
   * The reason belongs to a request that is still open. The revert button has
   * its own condition, decided by the host tab, so the two are kept apart: if
   * the states that allow a revert ever widen, the button must not vanish just
   * because there is no reason to show.
   */
  get isVisible(): boolean {
    return hasOpenCancelRequest(this.treatment);
  }

  get cancelRequest() {
    return resolveOpenCancelRequest(this.treatment);
  }

  get hasReason(): boolean {
    return !!this.cancelRequest?.reason_code;
  }

  get reasonLabel(): string {
    return resolveCancelRequestReason(this.treatment) ?? CANCEL_REASON_UNSELECTED;
  }

  get reasonText(): string | null {
    return resolveCancelRequestDetail(this.treatment);
  }

  get requestedAt(): string | null {
    return this.cancelRequest?.created_at ?? null;
  }

  get menuName(): string | null {
    return this.treatment?.menu?.name ?? null;
  }

  openConfirm() {
    this.$modal.show(this.confirmModalName);
  }
}
